import { render, staticRenderFns } from "./PsrMain.vue?vue&type=template&id=303385be&scoped=true&"
import script from "./PsrMain.vue?vue&type=script&lang=js&"
export * from "./PsrMain.vue?vue&type=script&lang=js&"
import style0 from "./PsrMain.vue?vue&type=style&index=0&id=303385be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303385be",
  null
  
)

export default component.exports